import {ReactComponent as HashtagIcon} from './hashtag.svg'

function Hashtag() {
  return <HashtagIcon />
}

export default Hashtag
